/** Shown in the order-success modal when a field is unknown (e.g. walk-in with no customer). */
export const ORDER_SUCCESS_EMPTY_VALUE = '—';

const WAY_ORDER_SUCCESS_SOURCE_EVENTS = new Set([
  'way-single-wash',
  'way-active-subscription',
  'way-purchase-selection',
]);

/**
 * Way redemptions hide the package price on order-success. Detected from Way identifiers
 * only: `auto_redeem` / `gate_opened` are also set on SaaS lane completions.
 */
export function isWayOrderSuccessPayload(data: Record<string, any> | null | undefined): boolean {
  if (String(data?.['way_pass_id'] ?? data?.['wayPassId'] ?? '').trim()) {
    return true;
  }
  const sourceEvents = data?.['source_events'];
  return (
    Array.isArray(sourceEvents) &&
    sourceEvents.some(event => WAY_ORDER_SUCCESS_SOURCE_EVENTS.has(String(event ?? '').trim()))
  );
}

/** Trimmed value, or the empty-state dash when blank. */
export function orderSuccessDisplayValue(value: unknown): string {
  return String(value ?? '').trim() || ORDER_SUCCESS_EMPTY_VALUE;
}

/** Customer full name from first/last parts, or the empty-state dash when both are blank. */
export function formatOrderSuccessCustomerName(firstName: unknown, lastName: unknown): string {
  const name = [firstName, lastName]
    .map(part => String(part ?? '').trim())
    .filter(Boolean)
    .join(' ');
  return orderSuccessDisplayValue(name);
}
